import { Cpu } from "lucide-react";

export const BotCommentary = ({ commentary, analyzing }) => {
  const text = commentary?.text;
  return (
    <div data-testid="bot-commentary" className="rounded-lg border border-[#A374FF]/25 bg-[var(--surface)] overflow-hidden">
      <div
        className="relative h-24 flex items-end p-5"
        style={{
          backgroundImage:
            "linear-gradient(to top, rgba(15,15,17,1) 10%, rgba(15,15,17,0.4) 60%, rgba(163,116,255,0.15)), url('https://images.unsplash.com/photo-1714548529197-537c1f0b6aa7?crop=entropy&cs=srgb&fm=jpg&w=800&q=80')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-[#A374FF]/20 border border-[#A374FF]/40 flex items-center justify-center">
            <Cpu className="h-4 w-4 text-[var(--accent)]" />
          </div>
          <div>
            <h3 className="font-head font-bold text-base leading-none">Bot Piyasa Yorumu</h3>
            <span className="text-[10px] text-[var(--accent)] tracking-widest">AI ANALİZ</span>
          </div>
        </div>
      </div>
      <div className="p-5">
        {analyzing ? (
          <div className="space-y-2 animate-pulse">
            <div className="h-3 bg-[var(--surface-hover)] rounded w-full" />
            <div className="h-3 bg-[var(--surface-hover)] rounded w-11/12" />
            <div className="h-3 bg-[var(--surface-hover)] rounded w-3/4" />
          </div>
        ) : text ? (
          <p className="text-sm leading-relaxed text-[var(--text-muted)]">{text}</p>
        ) : (
          <p className="text-sm text-[var(--text-faint)]">Analiz çalıştırıldığında botun piyasa yorumu burada görünecek.</p>
        )}
        {commentary?.updated_at && !analyzing && (
          <p className="text-[10px] text-[var(--text-faint)] mt-3 font-mono">
            Güncelleme: {new Date(commentary.updated_at).toLocaleString("tr-TR")}
          </p>
        )}
      </div>
    </div>
  );
};
